import { chakra, Button, Flex, IconButton, HStack } from '@chakra-ui/react';

export const UpvoteButton = chakra(Button, {
  baseStyle: {
    background: 'transparent',
    border: 'none',
    outline: 'none',
    padding: '0',
    width: 'max-content',
    minWidth: '30px',
    height: '30px',
    cursor: 'pointer',

    '&[aria-selected="true"]': {
      color: '#5b1cf4',
    },
  },
});

export const ReplyButton = chakra(IconButton, {
  baseStyle: {
    background: 'transparent',
    border: '1px solid transparent',
    color: 'black',
    borderRadius: '100%',
    minWidth: '30px',
    width: '30px',
    height: '30px',
    _hover: {
      border: '1px solid #CACCCC',
      background: 'transparent',
    },
  },
});

export const ChatMessageWrapper = chakra(HStack, {
  baseStyle: {
    backgroundColor: 'white',
    width: '100%',
    alignItems: 'flex-start',
    padding: '16px 20px 0px 20px',
  },
});

export const ChatMessageActions = chakra(Flex, {
  baseStyle: {
    direction: 'column',
    alignItems: 'center',
    gap: '5px',
    width: '100%',
    flexWrap: 'wrap',
  },
});
